import { Outlet } from 'react-router-dom'

import { SpendingPoliciesListPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import Landing from 'modules/finance/components/SpendingPolicies/List/Landing'
import Overview from 'modules/finance/components/SpendingPolicies/List/Overview'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const SpendingPoliciesListPage = () => {
  const { company } = useCurrentSession()

  const { loading, data, error } = useQuery(SpendingPoliciesListPageDocument, {
    variables: {
      companyId: company.id.toString(),
    },
  })

  const spendingPolicies = data?.finance?.spendingPoliciesConnection.nodes || []

  const canCreatePolicies = data?.finance?._policies.spendingPolicyCreate.can ?? false

  return (
    <ResponsivePage.Body variant="full" showHeader={false} loading={loading} error={error}>
      {spendingPolicies.length ? (
        <Overview canCreatePolicies={canCreatePolicies} spendingPolicies={spendingPolicies} />
      ) : (
        <Landing />
      )}
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default SpendingPoliciesListPage
